function StepApplyIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7 text-pink-500" aria-hidden="true">
      <rect x="3" y="4" width="18" height="16" rx="2.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M7 8h10M7 12h10M7 16h6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

function StepShieldIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7 text-pink-500" aria-hidden="true">
      <path d="M12 2.8 20 6v6c0 5.1-3.5 8.4-8 9.7-4.5-1.3-8-4.6-8-9.7V6l8-3.2Z" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="m9.2 12.1 1.8 1.8 3.8-3.8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function StepMoneyIcon() {
  return (
    <svg viewBox="0 0 24 24" className="h-7 w-7 text-pink-500" aria-hidden="true">
      <rect x="2.5" y="6.5" width="19" height="11" rx="3" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <circle cx="12" cy="12" r="2.8" fill="none" stroke="currentColor" strokeWidth="1.8" />
      <path d="M6.5 12h.01M17.5 12h.01" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}

export default function HomeSections() {
  return (
    <>
      <section id="how-it-works" className="bg-[#f8f2f7] px-4 py-12 sm:px-8 lg:px-12">
        <div className="mx-auto max-w-6xl">
          <h2 className="text-3xl font-bold text-slate-800 sm:text-4xl">How it works</h2>
          <div className="mt-6 grid gap-4 md:grid-cols-3">
            {[
              { title: "Apply online", text: "Complete a short digital form in minutes.", icon: <StepApplyIcon /> },
              { title: "Secure review", text: "We review your details with secure checks.", icon: <StepShieldIcon /> },
              { title: "Get paid", text: "Approved funds are sent to your account.", icon: <StepMoneyIcon /> },
            ].map((step) => (
              <article key={step.title} className="rounded-3xl border border-white/60 bg-white/80 p-5 shadow-xl backdrop-blur">
                {step.icon}
                <h3 className="mt-3 text-xl font-semibold text-slate-800">{step.title}</h3>
                <p className="mt-1 text-slate-600">{step.text}</p>
              </article>
            ))}
          </div>

          <div className="mt-5 rounded-2xl border border-pink-100 bg-pink-50/80 px-4 py-3 text-lg md:text-xl text-slate-700">
            <span className="font-semibold text-slate-800">What you&apos;ll need:</span> ID, payslip, bank statement & proof of address
          </div>
        </div>
      </section>

      <section id="benefits" className="bg-[#f8f2f7] px-4 pb-14 pt-12 sm:px-8 lg:px-12 lg:pb-20">
        <div className="mx-auto max-w-6xl">
          <h2 className="text-3xl font-bold text-slate-800 sm:text-4xl">Benefits</h2>
          <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {[
              ["Transparent estimates", "Know your costs before you apply."],
              ["Fast review", "Quick assessment with clear status updates."],
              ["Secure application", "Your details are handled with secure, modern controls."],
              ["Simple terms", "Clear repayment structure with admin fees included."],
              ["Fair fees", "Simple fee structure with fixed initiation and service fees."],
              ["Local support", "Friendly support team ready to help in your region."],
            ].map(([title, copy]) => (
              <article key={title} className="rounded-3xl border border-white/60 bg-white/80 p-5 shadow-xl backdrop-blur">
                <h3 className="text-lg font-semibold text-slate-800">{title}</h3>
                <p className="mt-2 text-slate-600">{copy}</p>
              </article>
            ))}
          </div>

          <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-3xl border border-pink-100 bg-gradient-to-r from-pink-50 to-white p-6 shadow-lg sm:flex-row">
            <p className="text-2xl font-semibold text-slate-800">Ready to apply?</p>
            <a
              href="https://5577-8888.webfin.co.za/webloans/"
              className="inline-flex items-center justify-center rounded-xl bg-gradient-to-b from-pink-400 to-pink-500 px-6 py-3 font-semibold text-white shadow-xl transition hover:brightness-90"
            >
              Apply Now
            </a>
          </div>
        </div>
      </section>

    </>
  );
}
